import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  searchOwnRequests,
  searchOwnRequestsCompleted,
} from "../../slices/own_requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleSearchOwnRequests({ page, items, filters }) {
  return await workflowsService.listUserOwnership(page, items, filters);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* searchOwnRequestsSaga({ payload }) {
  try {
    yield put(searchOwnRequests({ term: payload.filters }));
    const ownRequestsData = yield call(handleSearchOwnRequests, payload);
    const usersTokens = ownRequestsData.data.map((item) => item.user_token);
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    ownRequestsData.data = ownRequestsData.data.map((item) => {
      const user = usersData.find((user) => user.token === item.user_token);
      return {
        ...item,
        fullName: `${user.name} ${user.last_name}`,
      };
    });
    yield put(searchOwnRequestsCompleted(ownRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* searchOwnRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_SEARCH_LIST_OWN_REQUESTS,
    searchOwnRequestsSaga
  );
}
